
import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RegisterFormValues } from "@/types/auth";
import { CitySearch } from "@/components/CitySearch";

interface CompanyInfoFieldsProps {
  form: UseFormReturn<RegisterFormValues>;
}

export const CompanyInfoFields = ({ form }: CompanyInfoFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="organization_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Company</FormLabel>
            <FormControl>
              <Input 
                id="organization_name"
                placeholder="Company Name" 
                {...field} 
                className="bg-white border-gray-200" 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="city_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">City</FormLabel>
            <FormControl>
              <CitySearch 
                onSelect={(cityId) => form.setValue("city_id", cityId, { shouldValidate: true })} 
                defaultValue={field.value > 0 ? field.value : undefined}
                nextFieldId="first_name" // Pass the ID of the next field to focus
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
